import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { setSelectedReduxCalendar, setProgramType } from '../../ducks/calendarActions';

const SearchedCalendarDiv = styled('div')`
  cursor: pointer;
  margin-bottom: 10px;
  font-family: 'Nunito Sans';
  font-size: 16px;
  color: #444444;
  background-color: ${({ isSelected }) => (isSelected ? '#f0f0f0' : 'transparent')};
`;

const SubCalendarsContainer = styled('div')`
  height: ${({ isOpen, contentHeight }) => (isOpen && contentHeight > 0 ? `${contentHeight + 10}px` : '0')};
  overflow: hidden;
  transition: height 0.3s ease-in-out;
  padding-left: 65px;
  margin-top: 10px;
`;

const IconAndName = styled('div')`
  display: flex;
  align-items: center;
`;

const IconContainer = styled('div')`
  height: 100%;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.3s ease-in-out;
  transform: ${({ isOpen }) => (isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const SearchedCalendar = ({
  calendar, isSelected, isModal, closeModal,
}) => {
  const dispatch = useDispatch();

  return (
    <SearchedCalendarDiv
      onClick={() => {
        dispatch(setProgramType('calendar'));
        dispatch(setSelectedReduxCalendar(calendar));
        if (isModal && closeModal) {
          closeModal();
        }
      }}
      data-calendar-id={calendar.id}
      isSelected={isSelected}
    >
      <IconAndName>
        <IconContainer />
        <div>{calendar.name}</div>
      </IconAndName>
      <SubCalendarsContainer />
    </SearchedCalendarDiv>
  );
};

SearchedCalendar.defaultProps = {
  isSelected: false,
  isModal: false,
  closeModal: null,
};

SearchedCalendar.propTypes = {
  calendar: PropTypes.instanceOf(Object).isRequired,
  isSelected: PropTypes.bool,
  isModal: PropTypes.bool,
  closeModal: PropTypes.func,
};

export default SearchedCalendar;
